/* tslint:disable */

/**
 */
export class NumberConvert {
    number_convert?: number;
}
